import {storage} from '@nuskin/ns-util';
/**
 *
 * sitesSessionStorageService
 *
 * @namespace sitesSessionStorageService
 * @ignore
 */
let SitesSessionStorageService = function(){
    "use strict";

    const STORAGE_METADATA= storage.metadata.SITES_SS;
    let publicMethods = {};

    publicMethods.initStorage = function(){
        if (!storage(STORAGE_METADATA)) storage(STORAGE_METADATA, {});
    };

    publicMethods.getItem = function(key){
        publicMethods.initStorage();
        var storageVal = storage(STORAGE_METADATA);
        return storageVal && storageVal.hasOwnProperty(key) ? storageVal[key] : false;
    };

    publicMethods.writeItem = function(key, data){
        publicMethods.initStorage();
        var storageVal = storage(STORAGE_METADATA);
        if (storageVal) {
            storageVal[key] = data;
            storage(STORAGE_METADATA, storageVal);
            return storageVal[key];
        }
        return false;
    };

    publicMethods.removeItem = function(key){
        var storageVal = storage(STORAGE_METADATA);
        if (storageVal && storageVal[key]) {
            delete storageVal[key];
            storage(STORAGE_METADATA, storageVal);
            return true;
        }
        return false;
    };

    publicMethods.removeAll = function(){
        storage.removeItem(STORAGE_METADATA);
    };

    return publicMethods;
}();

export default SitesSessionStorageService;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/sitesSessionStorageService.js
// module id = 335
// module chunks = 0